'use es6';

import { createSelector } from 'reselect';
import { INITIALIZING, LOADING, EMPTY, ERROR, HAS_RESULTS, NO_RESULTS } from 'SalesContentIndexUI/data/constants/TableContentState';
import SearchStatus from 'SalesContentIndexUI/data/constants/SearchStatus';
import { totalSelector, allContentFilterListSelector, searchStatusSelector, searchQuerySelector } from './searchSelectors';
export const hasResultsSelector = createSelector(totalSelector, total => total > 0);
export const isInitializingSelector = search => search.isInitializing;
const hasFolderFilterWithValues = searchQuery => searchQuery.getFolderFilter() && searchQuery.getFolderFilter().values.size > 0;
const hasTeamFilterWithValues = searchQuery => searchQuery.getTeamFilter() && searchQuery.getTeamFilter().values.size > 0;
const hasUserFilterWithValues = searchQuery => searchQuery.getUserFilter() && searchQuery.getUserFilter().values.size > 0;
export const hasActiveSearchOrFolderOrOwnerSelector = createSelector(searchQuerySelector, searchQuery => {
  return hasFolderFilterWithValues(searchQuery) || hasTeamFilterWithValues(searchQuery) || hasUserFilterWithValues(searchQuery) || !!searchQuery.query;
});
export const isViewingAllContentSelector = createSelector(searchQuerySelector, allContentFilterListSelector, searchStatusSelector, (searchQuery, allContentFilterList, searchStatus) => {
  if (hasFolderFilterWithValues(searchQuery)) {
    return false;
  }
  if (searchQuery.offset > 0) {
    return false;
  }
  if (searchStatus !== SearchStatus.SUCCEEDED) {
    return false;
  }
  return !searchQuery.query && searchQuery.filters.toSet().equals(allContentFilterList.toSet());
});
export const isEmptyState = count => createSelector(hasResultsSelector, isViewingAllContentSelector, hasActiveSearchOrFolderOrOwnerSelector, (hasResults, isViewingAllContent, hasActiveSearchOrFolderOrOwner) => {
  if (count === 0) {
    return true;
  }
  if (hasResults) {
    return false;
  }
  if (isViewingAllContent) {
    return true;
  }
  return !hasActiveSearchOrFolderOrOwner;
});
export const isNoResultsState = count => createSelector(hasResultsSelector, isEmptyState(count), (hasResults, isEmpty) => {
  return !hasResults && !isEmpty;
});
export const isErrorState = createSelector(searchStatusSelector, searchStatus => searchStatus === SearchStatus.FAILED);
export const isLoadingState = createSelector(searchStatusSelector, searchStatus => searchStatus === SearchStatus.LOADING);
export const selectTableContentState = count => createSelector(isInitializingSelector, isLoadingState, isErrorState, isEmptyState(count), isNoResultsState(count), (isInitializing, isLoading, hasError, isEmpty, hasNoResults) => {
  if (isInitializing) {
    return INITIALIZING;
  }
  if (isLoading) {
    return LOADING;
  }
  if (hasError) {
    return ERROR;
  }
  if (isEmpty) {
    return EMPTY;
  }
  if (hasNoResults) {
    return NO_RESULTS;
  }
  return HAS_RESULTS;
});